<template>
  <div class="form-widget-container">
    <van-config-provider :z-index="pupupZIndex" style="height: 100%">
      <van-form class="full-height-width widget-form" :label-align="labelPosition" :class="[customClass, layoutType + '-layout']" :submit-on-enter="false" :style="formStyle">
        <div class="form-widget-canvas" :class="{ empty: designer.widgetList.length == 0 }" :empty-tip="i18nt('designer.noWidgetHint')">
          <draggable
            :list="designer.widgetList"
            item-key="id"
            v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 300 }"
            handle=".drag-handler"
            @end="onDragEnd"
            @add="onDragAdd"
            @update="onDragUpdate"
            :move="checkMove"
          >
            <template #item="{ element: widget, index }">
              <template v-if="'container' === widget.category">
                <component :is="getWidgetName(widget)" :widget="widget" :designer="designer" :key="widget.id" :parent-list="designer.widgetList" :index-of-parent-list="index" :parent-widget="null">
                  <template v-for="(idx, slotName) in $slots" #[slotName]="scope">
                    <slot :name="slotName" v-bind="scope"></slot>
                  </template>
                </component>
              </template>
              <template v-else>
                <component
                  :is="getWidgetName(widget)"
                  :field="widget"
                  :designer="designer"
                  :key="widget.id"
                  :parent-list="designer.widgetList"
                  :index-of-parent-list="index"
                  :parent-widget="null"
                  :design-state="true"
                >
                  <template v-for="(idx, slotName) in $slots" #[slotName]="scope"> <slot :name="slotName" v-bind="scope"></slot> </template
                ></component>
              </template>
            </template>
          </draggable>
        </div>
      </van-form>
    </van-config-provider>
  </div>
</template>

<script>
import { computed, getCurrentInstance, reactive, ref, nextTick, toRefs, provide, inject, watch, onMounted } from 'vue';

import '@/components/form-designer/form-widget/container-widget/index';
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';
import { useI18n } from '@/utils/i18n';

export default {
  componentName: 'VFormWidget',
  components: {
    ...FieldComponents,
  },
  name: 'VFormWidget',
  props: {
    designer: Object,
    formConfig: Object,
    globalDsv: {
      default: () => ({}),
      type: Object,
    },
    optionData: {
      default: () => ({}),
      // prop传入的选项数据
      type: Object,
    },
  },
  setup(props) {
    const { i18nt } = useI18n();

    const { proxy } = getCurrentInstance();
    let $current = proxy;

    const getDesignerConfig = inject('getDesignerConfig');

    const data = reactive({
      dsResultCache: {},
      formModel: {},
      widgetRefList: {},
    });

    provide('refList', data.widgetRefList);
    provide('getFormConfig', () => props.formConfig); /* 解决provide传递formConfig属性的响应式更新问题！！ */
    provide('getGlobalDsv', () => props.globalDsv); // 全局数据源变量
    provide('globalOptionData', props.optionData);
    provide('getOptionData', () => props.optionData);
    provide('getReadMode', () => false);
    provide('globalModel', { formModel: data.formModel });
    provide('getSubFormFieldFlag', () => false);
    provide('getSubFormName', () => '');
    provide('getDSResultCache', () => data.dsResultCache);

    const labelPosition = computed(() => {
      if (!!props.designer.formConfig && !!props.designer.formConfig.labelPosition) {
        return props.designer.formConfig.labelPosition;
      }

      return 'left';
    });

    const customClass = computed(() => {
      return props.designer.formConfig.customClass || '';
    });

    const layoutType = computed(() => {
      return props.designer.getLayoutType();
    });

    const pupupZIndex = computed(() => {
      return props.designer.formConfig.popupZIndex || 3000;
    });

    const formStyle = computed(() => {
      return {
        backgroundColor: props.designer.formConfig.background || '#FFFFFF',
        padding: (props.designer.formConfig.padding || 0) + 'px',
      };
    });

    const formFieldRadius = computed(() => {
      return (props.designer.formConfig.radius || 0) + 'px';
    });

    onMounted(() => {
      disableFirefoxDefaultDrop(); /* 禁用Firefox默认拖拽搜索功能!! */
      props.designer.registerFormWidget($current);
    });

    const getWidgetName = widget => {
      return widget.type + '-widget';
    };

    const disableFirefoxDefaultDrop = () => {
      let isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
      if (isFirefox) {
        document.body.ondrop = function (event) {
          event.stopPropagation();
          event.preventDefault();
        };
      }
    };

    const onDragEnd = evt => {
      // console.log('drag end000', evt)
    };

    const onDragAdd = evt => {
      const newIndex = evt.newIndex;
      if (props.designer.widgetList[newIndex]) {
        props.designer.setSelected(props.designer.widgetList[newIndex]);
      }

      props.designer.emitHistoryChange();
      props.designer.emitEvent('field-selected', null);
    };

    const onDragUpdate = () => {
      /* 在VueDraggable内拖拽组件发生位置变化时会触发update，未发生组件位置变化不会触发！！ */
      props.designer.emitHistoryChange();
    };

    const checkMove = evt => {
      return props.designer.checkWidgetMove(evt);
    };

    const getFormData = () => {
      return data.formModel;
    };

    const getWidgetRef = (widgetName, showError = false) => {
      let foundRef = data.widgetRefList[widgetName];
      if (!foundRef && !!showError) {
        $current.$message.error(i18nt('designer.hint.refNotFound') + widgetName);
      }
      return foundRef;
    };

    const getSelectedWidgetRef = () => {
      let wName = props.designer.selectedWidgetName;
      return getWidgetRef(wName);
    };

    props.designer.loadPresetCssCode(getDesignerConfig().presetCssCode);
    return {
      i18nt,

      ...toRefs(data),

      checkMove,
      customClass,
      disableFirefoxDefaultDrop,
      formFieldRadius,
      formStyle,
      getFormData,

      getSelectedWidgetRef,
      getWidgetName,

      getWidgetRef,
      labelPosition,
      layoutType,
      onDragAdd,

      onDragEnd,
      onDragUpdate,
      pupupZIndex,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-scroll-bar {
  :deep(.el-scrollbar__wrap),
  :deep(.el-scrollbar__view) {
    overflow-x: hidden;
  }
}

.form-widget-container {
  padding: 10px;
  background: #f1f2f3;

  overflow-x: hidden;
  overflow-y: auto;

  .van-form.full-height-width {
    height: 100%;
    background: #efefef;
    box-sizing: border-box;
    padding: 10px;

    .form-widget-canvas {
      //min-height: calc(100vh - 56px - 68px + 48px);
      padding: 3px;

      & > div {
        height: 100%;

        & > :deep(.field-wrapper):first-of-type {
          border-top-left-radius: v-bind(formFieldRadius);
          border-top-right-radius: v-bind(formFieldRadius);
          overflow: hidden;
          &.selected::after {
            border-top-left-radius: v-bind(formFieldRadius);
            border-top-right-radius: v-bind(formFieldRadius);
            overflow: hidden;
          }
        }
        & > :deep(.field-wrapper):last-of-type,
        > :deep(.field-wrapper):last-of-type.selected::after {
          border-bottom-left-radius: v-bind(formFieldRadius);
          border-bottom-right-radius: v-bind(formFieldRadius);
          overflow: hidden;
        }
      }

      &.empty {
        position: relative;
        &:after {
          position: absolute;
          content: attr(empty-tip);
          pointer-events: none;
          top: 0px;
          bottom: 0px;
          left: 0px;
          right: 0px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 18px;
          color: #999;
          padding: 0px 20px;
        }
      }
    }
  }

  /* 隐藏组件拖拽状态中显示的黑点 */
  :deep(li.container-widget-item),
  :deep(li.field-widget-item) {
    list-style: none;
  }

  .van-form.PC-layout {
    //
  }

  .van-form.Pad-layout {
    margin: 0 auto;
    max-width: 960px;
    border-radius: 15px;
    box-shadow: 0 0 1px 10px #495060;
  }

  .van-form.H5-layout {
    margin: 0 auto;
    width: 420px;
    border-radius: 15px;
    //border-width: 10px;
    box-shadow: 0 0 1px 10px #495060;
  }

  .van-form.widget-form :deep(.el-row) {
    padding: 2px;
    border: 1px dashed rgba(170, 170, 170, 0.75);
  }
}

.grid-cell {
  min-height: 30px;
  border-right: 1px dotted #cccccc;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
